var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailVerification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 29,
    r: 29,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6408 37.7959C27.9522 37.7959 24.1377 33.9668 24.1377 29.2603C24.1377 24.5537 27.9522 20.7246 32.6408 20.7246C37.3294 20.7246 41.1439 24.5537 41.1439 29.2603C41.1439 33.9668 37.3294 37.7959 32.6408 37.7959ZM32.6408 23.0907C29.2569 23.0907 26.5038 25.8583 26.5038 29.2603C26.5038 32.6622 29.2569 35.4298 32.6408 35.4298C36.0248 35.4298 38.7778 32.6622 38.7778 29.2603C38.7778 25.8583 36.0248 23.0907 32.6408 23.0907Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5445 32.1833L28.4106 29.6932L30.2073 28.1536L31.5003 29.6625L35.1782 25.9004L36.8701 27.5544L32.2888 32.2405C32.0658 32.4686 31.2116 32.7915 30.5445 32.1833Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4952 47.3232C21.4636 42.6316 17.4738 31.5027 17.7154 21.0583C17.7278 20.5185 18.1053 20.056 18.6322 19.9346C21.4614 19.2821 23.678 17.2474 23.6562 14.1862C23.6535 13.5404 24.1925 13 24.8394 13H40.4473C41.094 13 41.633 13.5402 41.6304 14.1859C41.5677 17.0659 43.7815 19.4619 46.5798 19.9199C47.1439 20.0122 47.5611 20.4938 47.5714 21.0643C47.7576 31.3743 43.2185 42.1067 33.8476 47.2254C33.4531 47.4408 32.733 47.9021 31.4952 47.3232ZM32.4569 45.1646C32.5387 45.2008 32.6316 45.1966 32.712 45.1527C35.656 43.5446 45.1097 37.1875 45.2108 22.0294C42.1519 21.1481 39.7614 18.5408 39.333 15.3625H25.9536C25.5249 18.5431 23.1314 21.1517 20.0696 22.0312C20.053 31.0951 23.5777 41.2216 32.4569 45.1646C32.5387 45.2009 31.2072 44.6096 32.4569 45.1646Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailVerification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-verification.a6f2bccd97384354f80bebf98d9dc4c7.svg";